export enum UserStatus {
	PENDING = "PENDING",
	ACTIVE = "ACTIVE",
	REGISTERED = "REGISTERED",
	CANCELED = "CANCELED",
	DELETED = "DELETED",
}
